import { createFileRoute } from '@tanstack/react-router'
import { CollectionAlerts } from '../../../../features/admin/CollectionAlerts'

/* ───── Route Definition ───── */

export const Route = createFileRoute(
  '/_authenticated/admin/collection/alerts',
)({
  component: AdminCollectionAlertsRoute,
})

/* ───── Route Component ───── */

function AdminCollectionAlertsRoute() {
  return <CollectionAlerts />
}
